var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgContract = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 22C5.66667 22 4.95833 21.7083 4.375 21.125C3.79167 20.5417 3.5 19.8333 3.5 19V16H6.5V2H21.5V19C21.5 19.8333 21.2083 20.5417 20.625 21.125C20.0417 21.7083 19.3333 22 18.5 22H6.5ZM18.5 20C18.7833 20 19.021 19.904 19.213 19.712C19.405 19.52 19.5007 19.2827 19.5 19V4H8.5V16H17.5V19C17.5 19.2833 17.596 19.521 17.788 19.713C17.98 19.905 18.2173 20.0007 18.5 20ZM9.5 9V7H18.5V9H9.5ZM9.5 12V10H18.5V12H9.5Z",
    fill: "#32008E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContract, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contract.816cccc0.svg";
export { ForwardRef as ReactComponent };